import { Link } from 'react-router-dom';
import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

// ###############################################################
// <---------------------- Campaigns List ----------------------->
// ###############################################################
export const Wrapper = styled.div`
  flex-grow: 1;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-template: 1fr / 6fr 9fr 5fr 6fr 9fr 5fr 5fr 12fr 22fr;
  column-gap: 16px;
  padding: 0 24px;
`;

export const Divider = styled.hr`
  width: calc(100% + 48px);
  grid-column: 1 / 11;
  margin: 0 -24px;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.grey003};
`;

export const Header = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 10px 0;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const ItemColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 68px;

  & > * + * {
    margin-top: 4px !important;
  }
`;

export const ItemRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 68px;

  & > * + * {
    margin-inline-start: 6px;
  }
`;

export const ItemWrapper = styled.div``;

export const ItemLink = styled(Link)`
  text-decoration: none;
`;

export const ItemText = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const ItemSubText = styled(typography.BodyTextTwoRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const ItemBtn = styled(typography.BodyTextTwoRegularTypography)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme, backgroundColor }) => backgroundColor || theme.colors.blueMain};
  border: 0px;
  border-radius: 4px;
  cursor: pointer;

  &:before {
    content: ${({ icon }) => icon};
    font-family: icomoon;
    font-size: 18px;
  }
`;

export const ItemStatus = styled(typography.BodyTextTwoRegularTypography)`
  width: 100px;
  margin: 0;
  padding: 5px 0;
  text-align: center;
  border-radius: 4px;

  ${({ color, backgroundColor }) => `
    color: ${color};
    background-color: ${backgroundColor};
  `};
`;

export const ItemTag = styled(typography.BodyTextThreeRegularTypography)`
  margin: 0;
  padding: 2px 4px;
  width: fit-content;
  color: ${({ theme }) => theme.colors.blueMain};
  background-color: ${({ theme }) => theme.colors.blueLight};
  border-radius: 4px;
  text-align: center;
`;
// ###############################################################
// <-------------------- End Campaigns List --------------------->
// ###############################################################

// ###############################################################
// <------------------ Campaign Actions Popup ------------------->
// ###############################################################
export const ActionsPopupWrapper = styled.div`
  padding: 30px 0;
  min-width: 550px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
`;

export const ActionsPopupTitleWrapper = styled.div`
  text-align: center;
`;

export const ActionsPopupTitle = styled(typography.TitleTwoTypography)`
  margin: 0;
`;

export const ActionsPopupBtnWrapper = styled.div`
  display: flex;
  padding: 0 20px;

  & * + * {
    margin-inline-start: 15px !important;
  }
`;

export const ActionsPopupYesBtn = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 8px 0;
  width: 60px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.greenMain};
  border: 0;
  border-radius: 4px;
  cursor: pointer;
`;

export const ActionsPopupNoBtn = styled(ActionsPopupYesBtn)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redMain};
  background-color: ${({ theme }) => theme.colors.redLight};
`;
// ###############################################################
// <------------- End Order Campaign Actions Popup -------------->
// ###############################################################
